// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 237 ? "component---gatsby-theme-project-portal-src-pages-404-tsx" : chunkId) + "-" + {"36":"ef3db320637f499ce532","237":"eea542c66c097c70ecca","698":"26e87bcb9a7a7174d265"}[chunkId] + ".js";
};